import { resolveCountry } from "./FormatByCountry";

const formatDecimal = (value: string) => {
  if (!value) return value.toString();
  const str = value.toString();
  const country = resolveCountry();
  if (country === "MY") {
    return str
      .replace(/[^0-9.]/g, "")
      .replace(/\.+/g, ".")
      .replace(/\.(\d+)\./g, ".$1");
  }
  // ID: desimal koma
  return str
    .replace(/[^0-9,.]/g, "")
    .replace(/[,.]+/g, ",")
    .replace(/,(\d+),/g, ",$1");
};
export default formatDecimal;
